import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-00594e12")

_pushScopeId("data-v-00594e12")
const _hoisted_1 = { class: "\n        flex flex-row\n        justify-between\n        items-center\n        border-b border-gray-lp-400\n      " }
const _hoisted_2 = { class: "flex flex-row my-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-20px mr-4 text-black-lp-200" }, " Ubah Transportasi ", -1)
const _hoisted_4 = { class: "inline-flex" }
const _hoisted_5 = {
  key: 1,
  class: "flex flex-row py-6 h-screen text-12px xxl:text-14px"
}
const _hoisted_6 = { class: "w-2/3 px-4 overflow-y-auto" }
const _hoisted_7 = { class: "py-3 w-3/4" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Kode Transportasi", -1)
const _hoisted_9 = { class: "py-3 w-3/4" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Nama Vendor", -1)
const _hoisted_11 = { class: "flex flex-row w-3/4" }
const _hoisted_12 = { class: "py-3 w-1/2 mr-4" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Kode Vendor", -1)
const _hoisted_14 = { class: "py-3 w-1/2" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Tipe Transportasi", -1)
const _hoisted_16 = { class: "\n            flex flex-col\n            h-full\n            text-12px\n            border-t border-gray-lp-400\n            my-6\n            py-6\n          " }
const _hoisted_17 = { class: "py-3" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, " Status Transportasi ", -1)
const _hoisted_19 = { class: "my-1 text-gray-lp-500 max-w-md" }
const _hoisted_20 = { class: "flex flex-row text-12px xxl:text-14px items-center text-black-lp-300" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "toggle-knob bg-white inline-block" }, null, -1)
const _hoisted_22 = { class: "ml-4" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "h-screen border-l" }, null, -1)
const _hoisted_24 = { class: "w-1/3 px-8 border-gray-lp-400" }
const _hoisted_25 = { class: "py-3" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Status Transportasi", -1)
const _hoisted_27 = { class: "my-1 text-black-lp-300" }
const _hoisted_28 = { class: "flex" }
const _hoisted_29 = { class: "py-3" }
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Tanggal Dibuat", -1)
const _hoisted_31 = { class: "my-1 text-black-lp-300" }
const _hoisted_32 = { class: "text-gray-lp-500" }
const _hoisted_33 = { class: "py-3" }
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Tanggal Diubah", -1)
const _hoisted_35 = { class: "my-1 text-black-lp-300" }
const _hoisted_36 = { class: "text-gray-lp-500" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_PageDetailLazyLoad = _resolveComponent("PageDetailLazyLoad")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createBlock(_component_PageDetailLazyLoad, {
        key: 0,
        onBack: _ctx.goBack
      }, null, 8, ["onBack"]))
    : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("img", {
              src: _imports_0,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
              class: "w-5 mr-3 cursor-pointer",
              alt: "back"
            }),
            _hoisted_3
          ]),
          _createVNode("div", _hoisted_4, [
            _withDirectives(_createVNode(_component_button_fill, {
              title: "Simpan",
              onClick: _ctx.onOpenSave,
              class: "px-8 bg-red-lp-300"
            }, null, 8, ["onClick"]), [
              [_vShow, !_ctx.isError]
            ])
          ])
        ]),
        (_ctx.isError)
          ? (_openBlock(), _createBlock(_component_ErrorMessage, {
              key: 0,
              errorType: _ctx.errorCause,
              onTryAgain: _ctx.fetchTransportData
            }, null, 8, ["errorType", "onTryAgain"]))
          : (_openBlock(), _createBlock("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode("input", {
                    type: "text",
                    placeholder: _ctx.dataDetail.transportCode,
                    class: 
              `py-1.5 xxl:py-3 px-4 rounded border border-gray-lp-400 focus:outline-none focus:shadow my-1 text-black-lp-300 w-full ${_ctx.isDisabled &&
                'bg-white'}`
            ,
                    disabled: _ctx.isDisabled
                  }, null, 10, ["placeholder", "disabled"])
                ]),
                _createVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode("input", {
                    type: "text",
                    placeholder: _ctx.dataDetail.vendorName,
                    class: 
              `py-1.5 xxl:py-3 px-4 rounded border border-gray-lp-400 focus:outline-none focus:shadow my-1 text-black-lp-300 w-full ${_ctx.isDisabled &&
                'bg-white'}`
            ,
                    disabled: _ctx.isDisabled
                  }, null, 10, ["placeholder", "disabled"])
                ]),
                _createVNode("div", _hoisted_11, [
                  _createVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createVNode("input", {
                      type: "text",
                      placeholder: _ctx.dataDetail.vendorCode,
                      class: 
                `py-1.5 xxl:py-3 px-4 rounded border border-gray-lp-400 focus:outline-none focus:shadow my-1 text-black-lp-300 w-full ${_ctx.isDisabled &&
                  'bg-white'}`
              ,
                      disabled: _ctx.isDisabled
                    }, null, 10, ["placeholder", "disabled"])
                  ]),
                  _createVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createVNode("input", {
                      type: "text",
                      placeholder: _ctx.dataDetail.transportType,
                      class: 
                `py-1.5 capitalize xxl:py-3 px-4 rounded border border-gray-lp-400 focus:outline-none focus:shadow my-1 text-black-lp-300 w-full ${_ctx.isDisabled &&
                  'bg-white'}`
              ,
                      disabled: _ctx.isDisabled
                    }, null, 10, ["placeholder", "disabled"])
                  ])
                ]),
                _createVNode("div", _hoisted_16, [
                  _createVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createVNode("div", _hoisted_19, " Klik tombol dibawah untuk " + _toDisplayString(_ctx.isStatus ? "menonaktifkan" : "mengaktifkan") + " transportasi. Anda dapat mengubah status kapan saja. ", 1)
                  ]),
                  _createVNode("div", _hoisted_20, [
                    _createVNode("div", {
                      onClick: _cache[2] || (_cache[2] = () => _ctx.onOpenStatus()),
                      class: 
                `toggle-switch inline-block cursor-pointer ${
                  _ctx.isStatus ? 'toggle-active bg-red-lp-100' : 'bg-gray-lp-200'
                }`
              
                    }, [
                      _hoisted_21
                    ], 2),
                    _createVNode("div", _hoisted_22, _toDisplayString(_ctx.isStatus ? "Aktif" : "Tidak Aktif"), 1)
                  ])
                ])
              ]),
              _hoisted_23,
              _createVNode("div", _hoisted_24, [
                _createVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createVNode("div", _hoisted_27, [
                    _createVNode("div", _hoisted_28, [
                      _createVNode("div", {
                        class: 
                  `rounded-full px-2 py-0 font-medium ${
                    _ctx.isStatus ? 'bg-green-lp-300' : 'bg-red-lp-600'
                  } ${_ctx.isStatus ? 'text-green-lp-200' : 'text-red-lp-500'}`
                
                      }, _toDisplayString(_ctx.isStatus ? "Active" : "Inactive"), 3)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createVNode("div", _hoisted_31, _toDisplayString(_ctx.createdAt), 1),
                  _createVNode("div", _hoisted_32, _toDisplayString(_ctx.dataDetail.createdBy), 1)
                ]),
                _createVNode("div", _hoisted_33, [
                  _hoisted_34,
                  _createVNode("div", _hoisted_35, _toDisplayString(_ctx.updatedAt), 1),
                  _createVNode("div", _hoisted_36, _toDisplayString(_ctx.dataDetail.updatedBy), 1)
                ])
              ])
            ])),
        (_ctx.isErrorEdit)
          ? (_openBlock(), _createBlock(_component_ErrorMessage, {
              key: 2,
              onCancel: _ctx.handleErrorClose,
              errorType: _ctx.errorCause,
              onTryAgain: _ctx._onEdit,
              modal: ""
            }, null, 8, ["onCancel", "errorType", "onTryAgain"]))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_Modal, {
          onClose: _ctx.onCloseStatus,
          onSubmit: _ctx.changeStatus,
          title: "Konfirmasi Penonaktifan",
          message: "Penonaktifan status akan membuat transportasi tidak dapat digunakan dalam Rute & Leg Management serta Rute Mapping.",
          image: "warning",
          textSuccess: "Nonaktifkan",
          textCancel: "Kembali",
          class: "px-8"
        }, null, 8, ["onClose", "onSubmit"]), [
          [_vShow, _ctx.openStatus]
        ]),
        _withDirectives(_createVNode(_component_Modal, {
          onSubmit: _ctx.onCloseActivateFailed,
          title: "Pengaktifan Gagal !",
          message: "Mohon lakukan pengecekan status data vendor yang Anda pilih.",
          image: "warning",
          textSuccess: "OK",
          class: "px-8"
        }, null, 8, ["onSubmit"]), [
          [_vShow, _ctx.isErrorVendorStatus]
        ]),
        _withDirectives(_createVNode(_component_Modal, {
          onSubmit: _ctx.onCloseSuccess,
          title: "Perubahan Disimpan",
          message: 
        `Detail transportasi “${_ctx.dataDetail.transportCode}” berhasil diubah`
      ,
          image: "image-modal-success",
          textSuccess: "OK",
          class: "px-8"
        }, null, 8, ["onSubmit", "message"]), [
          [_vShow, _ctx.openSuccess]
        ]),
        _withDirectives(_createVNode(_component_Modal, {
          onSubmit: _ctx.handlerClose,
          onClose: _ctx.handlerCancelClose,
          title: "Yakin Keluar Halaman ?",
          message: "Anda belum selesai mengisi form. Permintaan tidak akan diproses jika Anda keluar dari halaman ini.",
          image: "are-you-sure",
          textSuccess: "Keluar",
          textCancel: "Kembali",
          class: "px-8"
        }, null, 8, ["onSubmit", "onClose"]), [
          [_vShow, _ctx.isEditTerminated]
        ]),
        _withDirectives(_createVNode(_component_Modal, {
          onSubmit: _ctx._onEdit,
          onClose: _ctx.onCloseSave,
          title: "Konfirmasi Perubahan",
          message: 
        `Anda yakin ingin menyimpan perubahan detail transportasi “${_ctx.dataDetail.transportCode}“ ?`
      ,
          image: "are-you-sure",
          textSuccess: "Simpan",
          textCancel: "Kembali",
          class: "px-8"
        }, null, 8, ["onSubmit", "onClose", "message"]), [
          [_vShow, _ctx.openSave()]
        ])
      ], 64))
})